module.exports = __webpack_public_path__ + "media/assets/google_classroom_logo-ff40cb211383683755f0886c02a11f71.png";